<template>
<!-- 订单新增 -->
    <div class="import-detail-edit" >
        <el-form :model="dataForm" ref="dataForm" label-position="top"  class="dataForm" :rules="rules" scroll-to-error>
        <div class="biz-type" v-if="bizType && bizType.length" @click="getBizType">
            <span v-if="dataForm.bizType == '01'">
               发票类型：13% 增值税专用发票
            </span>
            <span v-if="dataForm.bizType == '02'">
                发票类型：海关税票+6% 服务费发票 
            </span>
            <span v-if="!dataForm.bizType" class="is-error"><span style="color:#ff187b;">* </span>选择发票类型 </span>
            <ab-svg name="fankui" v-if="bizType.length > 1" ></ab-svg>
        </div>
        
        <div class="tax-limit clearfix" :class="{'is-taxes': !dataForm.isTaxesAdvanced}" v-if="dataForm.taxIsEnabled">
            <div class="limit-left" >
                <!-- <el-icon><ArrowDownBold /></el-icon> -->
                <el-checkbox v-model="dataForm.isTaxesAdvanced"  :true-label="1" :false-label="0">垫税</el-checkbox>
            </div>
            <div class="msg-center" >
                垫税可用额度 
                <div class="number">{{dataForm.taxFree}} <span class="by">(CNY)</span></div>
            </div>
            <div class="msg-right">
                <div  @click="handlerLimit">
                    <ab-svg name="add" style="margin-right: 10px;" v-if="dataForm.applyStatus != 2"></ab-svg>
                    <ab-svg name="progress" style="margin-right: 10px;" v-else></ab-svg>
                    <span v-if="dataForm.applyStatus != 2">提额</span>
                    <span v-else>进度</span>
                </div>
            </div>
        </div>
        <div class="title-1">
            收发货信息
        </div>
        <div class="consignee clearfix">
            <div class="logo">
                <el-popover
                    placement="top-end"
                    popper-class="form-pop"
                    :width="300"
                    trigger="hover"
                    content="境外把要报关的货物交给一咻"
                >
                    <template #reference>
                        <ab-svg name="jwjiao"></ab-svg>
                    </template>
                </el-popover>
                <div class="step-line" :style="{'height': stepline()}"></div>
                <div class='normal'></div>
                <div class="jiantou">
                    <ab-svg name="jiantou"></ab-svg>
                </div>
                <el-popover
                    placement="top-end"
                    popper-class="form-pop"
                    :width="300"
                    trigger="hover"
                    content="境内把已报关的货物交至指定地址"
                >
                    <template #reference>
                        <ab-svg name="guoneishou"></ab-svg>
                    </template>
                </el-popover>
            </div>
            <div class="content">
                <el-row>
                    <el-col :span="24">
                        <el-form-item  prop="supplierName" style="margin-bottom:20px">
                            <ab-select2
                                url="/bas/client/basSupplier/listByName"
                                inputKey="nameOrNumber"
                                descKey="name"
                                ref="supplerSelect"
                                v-model="dataForm.supplierName"
                                placeholder="供应商通常是PI上的卖方, 是贵司委托我司向境外付汇的对象"
                                label="供应商"
                                popover="供应商通常是PI上的卖方, 是贵司委托我司向境外付汇的对象"
                                required
                                @handleSelect="changeSupplier"
                                @handlerAdd="handleAddSupplier"
                            >
                            </ab-select2>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <div class="incoming-div"  v-if="dataForm.incomingAddress && dataForm.supplierMethod == '02'">
                            <ab-svg name="dingwei2"></ab-svg>
                            {{incomingRemarks}}
                        </div>
                        <div class="incoming-div"  v-if="dataForm.supplierMethod == '01'">
                            <ab-svg name="dingwei2"></ab-svg>
                            送货地址：香港沙田安平街8号偉達中心8楼樓801室 | 联系人：羅占偉 00852-26089369 
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <el-row :gutter="25">
                          <el-col :span="8" class="form-item-a">
                            <el-form-item  prop="supplierMethod" style="margin-bottom:50px">
                                <template #label>
                                    <el-popover
                                        placement="top-end"
                                        popper-class="form-pop"
                                        :width="300"
                                        trigger="hover"
                                        content="指要贵司的供应商如何把需进口的货物交给一咻"
                                    >
                                        <template #reference>
                                            交货方式
                                        </template>
                                    </el-popover>
                                </template>
                                <el-popover
                                    placement="top-end"
                                    popper-class="form-pop"
                                    :width="300"
                                    trigger="hover"
                                >
                                    
                                    <div v-if="dataForm.incomingAddress && dataForm.supplierMethod == '02'">
                                        {{incomingRemarks}}
                                    </div>
                                    <!-- <div v-else-if="dataForm.supplierMethod == '01'">
                                        <span class="hk-adress">
                                            香港仓：香港沙田安平街8号偉達中心8楼樓801室 | 联系人：羅占偉 00852-26089369 要求：随货发票箱单一式两份，备注入仓号 | 下载<u style="cursor: pointer; color: #0b7aff" @click="downloadRecePdf('https://scp-static.oss-cn-shenzhen.aliyuncs.com/receiptInfo/香港收货指引-锦盛伟达仓.pdf')"> 收货指引 </u>
                                        </span>
                                    </div> -->
                                    <div v-else="!dataForm.supplierMethod"> 供应商送货方式有六种，根据实际情况选择</div>
                                    <template #reference>
                                        <el-select   v-model="dataForm.supplierMethod" placeholder="请选择" @change="methodChange">
                                            <el-option 
                                                :label="obj.desc" 
                                                :value="obj.value" 
                                                :key="idx"
                                                v-for="(obj,idx) in supplierOptions">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-popover>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8" v-if="dataForm.supplierMethod == '06'" class="form-item-a">
                            <el-form-item label="区域" prop="supplierMethodAddressId">
                                <ab-address  v-model="dataForm.supplierMethodAddressId" placeholder="请选择寄件地区" ></ab-address>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8" v-if="dataForm.supplierMethod == '06' && dataForm.supplierMethodAddressId && !isHKchange" class="form-item-a">
                            <div style="margin-top: 40px;">
                                <el-alert class="ab-lert"  :closable="false" title="从非香港地区发快递到香港会产生【香港清关费】" type="warning" ></el-alert>
                            </div>
                          </el-col>
                          <el-col :span="3" v-if="dataForm.supplierMethod == '02'" class="form-item-a">
                            <div class="basics-label" @click="checkedPickUp">
                                
                                <p v-if="!dataForm.incomingAreaId"><ab-svg name="add"></ab-svg>新增提货</p>
                                <p v-else class="edit-incoming"><el-icon><Edit /></el-icon>修改提货</p>
                            </div>
                          </el-col>
                          
                        <el-col :span="8" v-if="['03','04','05'].includes(dataForm.supplierMethod)" class="form-item-a">
                            <el-form-item :label="['','','机场名称','码头名称','保税区名称'][Number(dataForm.supplierMethod) - 1]"  prop="supplierMethodLabel" >
                                <el-input :disabled="isEdit || isDisabled" :placeholder="['','','请输入机场名称','请输入码头名称','请输入保税区名称'][Number(dataForm.supplierMethod) - 1]"  v-model="dataForm.supplierMethodLabel"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="8" v-if="dataForm.supplierMethod == '03'" class="form-item-a">
                            <el-row :gutter="25">
                                <el-col :span="9">
                                    <el-form-item label="快递公司及单号"  prop="supplierCarrierId">
                                        <el-select size="mini" @change="changCarrier"  v-model="dataForm.supplierCarrierId" placeholder="请选择运输商">
                                            <el-option
                                            v-for="item in listCarrier"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="15" class="form-item-a">
                                    <el-form-item label="" class="basics-label1" prop="supplierCourierNumber" :rules="[
                                            { required: dataForm.supplierCarrierId, message: '请填写单号', trigger: ['change', 'blur'] }
                                        ]">
                                        <el-input :disabled="isEdit || isDisabled || !dataForm.supplierCarrierId" maxlength="200" placeholder="请录入单号（不含快递公司名字）" size="mini" v-model="dataForm.supplierCourierNumber"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>

                        </el-row>
                    </el-col>
                    
                    <el-col :span="24">
                        
                    </el-col>
                    
                </el-row>
                <domesticDelivery 
                    :dataForm="dataForm"
                    ref="domesticDelivery"
                    :typeList="typeList"
                ></domesticDelivery>
                

            </div>
        </div>
            <div class="cargoInfo">
               
                <orderDetail 
                    :packingTypeList="typeList.packingTypeList"
                    sourceType="import"
                    :dataForm="dataForm"
                    :deleteArr="deleteArr"
                    @aiSuccess="$emit('aiSuccess')"
                    @save="autoSave"
                    ref="ordersDetail"
                ></orderDetail>
            
               
            </div>
        </el-form>
        

        <el-dialog
            :title="addPickupDialog.title"
            v-model="addPickupDialog.show"
            top="5vh"
            width="718px"
            class="no-min-height"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            :close="closeDialog"
            >
                <el-form :model="addPickupDialog" :rules="addPickupDialog.rules" ref="addPickupDialog" label-position="top">
                    <el-row :gutter="25">
                        <el-col :span="12">
                            <el-form-item label="详细地址" prop="incomingAddress">
                                <ab-select
                                    url="/bas/client/basSupplier/entryAddressList"
                                    inputKey="linkAddress"
                                    isAdd
                                    describe="linkman"
                                    descKey="linkAddress"
                                    @handleSelect="handleSelect"
                                    v-model="addPickupDialog.incomingAddress"
                                    :urlData="{linkAddress: addPickupDialog.incomingAddress, supplierId: this.dataForm.supplierId,  pageSize: 10, pageNum: 1}"
                                    >
                                    </ab-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="区域" prop="incomingAreaId">
                                <ab-address v-model="addPickupDialog.incomingAreaId"  disabled></ab-address>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人"  prop="incomingLinkman">
                                <el-input    maxLength='50' v-model="addPickupDialog.incomingLinkman" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话"  prop="incomingContactNumber">
                                <el-input   maxLength='40'  v-model="addPickupDialog.incomingContactNumber" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        
                        
                        <el-col :span="12">
                            <el-form-item label="提货时间"  prop="incomingTime" >
                                <ab-dateTimePick  v-model="addPickupDialog.incomingTime"  :gutter="10" ></ab-dateTimePick>
                                 
                            </el-form-item>
                        </el-col>
                        
                        <el-col :span="12">
                            <el-form-item label="件数"  prop="incomingTotalPackedQty">
                                <el-input     v-model="addPickupDialog.incomingTotalPackedQty" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="默认地址"  prop="isDefault">
                                <el-select   placeholder v-model="addPickupDialog.isDefault" disabled>
                                    <el-option :label="item.name" :value="item.value" v-for="(item,idx) in [{name: '是', value: 1}, {name: '否', value: 0}]" :key="idx"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button type="primary" :loading="btnLoading" @click="confirmDialog">确定</el-button>
                        <el-button @click="closeDialog">取消</el-button>
                    </span>
                </template>
           </el-dialog>
        <ab-handlerAds :dialog="addressData"  ref="handlerAds" @change="handlerAddress" @handlerChange="submitLinkman"></ab-handlerAds>

        <el-dialog
                :title="supplierDialog.title"
                v-model="supplierDialog.show"
                top="5vh"
                width="800px"
                class="no-min-height"
                :append-to-body="true"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :close="supplierDialog"
                @close="closeSupplier">
                <el-form :model="supplierDialog" :rules="supplierDialog.rules" ref="supplierDialog" label-position="top">
                    <el-row :gutter="25">
                        <el-col :span="24">
                            <el-form-item label="供应商全称"  prop="name" style="margin-bottom: 20px">
                                <ab-select
                                    url="/bas/client/basSupplier/listByName"
                                    inputKey="name"
                                    isNotClear
                                    placeholder="请输入英文名称，如有括号，请采用英文输入法下的括号"
                                    @handleSelect="changeNewSupplier"
                                    v-model="supplierDialog.name"
                                    :urlData="{name: supplierDialog.name, pageNum: 1, pageSize: 10, isEnabled: 1}"
                                ></ab-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-row :gutter="25">
                                <el-col :span="12">
                                    <el-form-item label="注册地址"  prop="address">
                                        <el-input size="mini" maxLength='200' v-model="supplierDialog.address" placeholder="请输入"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="区域" prop="areaIdDesc">
                                        <ab-address v-model="supplierDialog.areaIdDesc" @change="selectArea"></ab-address>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="SWIFT/联行号" prop="number">
                                        <ab-select
                                            url="/bas/basBank/pageList"
                                            placeholder="请输入SWIFT号/联行号"
                                            inputKey="number"
                                            descKey="number"
                                            isNotClear
                                            v-model="supplierDialog.number"
                                            :urlData="{pageNum: 1, pageSize: 10}"
                                            @handleSelect="bankChange"
                                        >
                                        </ab-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="国家地区" prop="countryName">
                                        <ab-select
                                            url="/bas/basArea/listCountry"
                                            placeholder="请选择国家地区"
                                            inputKey="keyWord"
                                            descKey="name"
                                            isNotClear
                                            v-model="supplierDialog.countryName"
                                            :urlData="{pageNum: 1, pageSize: 10, type: 1, isEnabled: 1}"
                                            @handleSelect="countryChange"
                                            :disabled="supplierDialog.bank !== '' && supplierDialog.number !== ''"
                                            >
                                        </ab-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="开户银行" prop="bankName">
                                        <el-input size="mini" maxLength='200' v-model="supplierDialog.bankName" placeholder="请输入" clearable :disabled="supplierDialog.bank !== '' && supplierDialog.number !== ''"></el-input>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="银行账号" prop="account">
                                        <el-input size="mini" maxLength='200' v-model="supplierDialog.account" placeholder="请输入" clearable></el-input>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="币别" prop="currencyIdDesc">
                                        <ab-select
                                            url="/bas/basCurrency/list"
                                            placeholder="请输入币别"
                                            inputKey="name"
                                            descKey="name"
                                            cueString="币别"
                                            v-model="supplierDialog.currencyIdDesc"
                                            :urlData="{pageNum: 1, pageSize: 10}"
                                            @handleSelect="currencyChange"
                                        ></ab-select>
                                    </el-form-item>
                                </el-col>
                                
                                <el-col :span="24">
                                    <el-form-item label="　">
                                        <ab-fileBtn v-model="fileData" @change="changefileData" @getTempBillId="updateBillsId2"></ab-fileBtn>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <ab-alert :fileList="fileList"></ab-alert>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-form>
                <template #footer>
                    <span  class="dialog-footer">
                        <el-button type="primary" :loading="supplierDialog.btnLoading" @click="supplierConfigDialog">确定</el-button>
                        <el-button @click="closeSupplier">取消</el-button>
                    </span>
                </template>
            </el-dialog>
            <ab-boost-limit :limitDrawer="limitDrawer"></ab-boost-limit>
            <el-dialog
                v-model="bizTypeDialog.show"
                title="发票类型"
                class="bizType-dialog"
                append-to-body
                width="512px"
                :before-close="bizTypeClose"
            >
            <div>
                <div class="org-item" @click="chenckedType(obj.type)" :class="{'isActived': invockType == obj.type}" v-for="(obj, idx) in bizType" :key="idx">
                    <div class="org-tel">
                        <el-icon><ArrowDownBold /></el-icon>
                    </div>
                    <div class="org-name">{{obj.typeDesc}}</div>
                </div>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="bizTypeClose">取消</el-button>
                    <el-button type="primary" @click="setBizType">
                    确定
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import domesticDelivery from './domestic-delivery.vue'
import orderDetail from './orders-detail.vue'
export default {
    components: {
        domesticDelivery,
        orderDetail
    },
    data () {
        const numberVai = (rule, value, callback) => {
            if (value) {
                console.log(value.length);
                if(value.length == 8 || value.length == 11) {
                if(!/^[a-zA-Z]+$/.test(value) && !/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/.test(value)) {
                    callback(new Error(`长度为${value.length}位时，只能是纯字母或字母+数字`))
                }
                }else if(value.length == 12) {
                if(!/^[0-9]*$/.test(value)) {
                    callback(new Error('长度为12位时，只能是纯数字'))
                }
                }else {
                callback(new Error('长度只能为8位，11位，12位'))
                }
                callback()
            } else {
                callback()
            }
        }
        return {
            // 附件数据
            fileData: {
                sourceBillId: '',
                attachType: '020',
                sourceBillType: 'Supplier',
                sourceBillNumber: ''
            },
            fileList: [],
            isDisabl2: false,
            currency:'',//币别
            rules: {
                supplierMethod: [
                    { required: true, message: '请选择交货方式', trigger: 'change'}
                ],
                supplierName: [
                    { required: true, message: '请选择供应商', trigger: 'change'}
                ],
                isAddress:[
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                shippingMethod:[
                    { required: true, message: '请选择送货方式', trigger: 'change'}
                ],
                signatureMethod:[
                    { required: true, message: '请选择签收方式', trigger: 'change'}
                ],
                coupons:[
                    { required: true, message: '请选择优惠券', trigger: 'change'}
                ],
                balance:[
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                modePriceDesc: [
                    { required: true, message: '请选择优惠券', trigger: 'change'}
                ],
                supplierMethodAddressId: [
                    { required: true, message: '请选择区域', trigger: 'change'}
                ],
                supplierMethodLabel: [
                    { required: true, message: '请输入名称', trigger: 'blur'}
                ],
            },
            isType: false,
            invockType: '',
            options: [],
            supplierOptions: [
                {value: '01', desc: '送货到香港仓（非快递送货）'},
                {value: '06', desc: '送货到香港仓（快递送货）'}, 
                {value: '02', desc: '需香港本地提货'},
                {value: '03', desc: '送货到国内机场'},
                {value: '04', desc: '送货到国内码头'},
                {value: '05', desc: '送货到保税区'}
            ],
            addPickupDialog: {
                show: false,
                title: '',
                rules: {
                    incomingAddress: [
                        { required: true, message: '请选择提货地址', trigger: 'change'}
                    ],
                    incomingAreaId: [
                        { required: true, message: '请选择区域', trigger: 'blur'}
                    ],
                    incomingLinkman: [
                        { required: true, message: '请输入联系人', trigger: 'blur'}
                    ],
                    incomingContactNumber: [
                        { required: true, message: '请输入联系电话', trigger: 'blur'}
                    ],
                    incomingTime: [
                        { required: true, message: '请选择提货时间', trigger: 'change'}
                    ],
                    incomingTotalPackedQty: [
                        { required: true, message: '请输入件数', trigger: 'blur'},
                        { validator: (rule, value, callback) => {
                            if(!value || !value.trim()) {
                                return callback(new Error('件数不能为空!'))
                            }else if(!/^[0-9]+$/.test(value) || value === 0) {
                                return callback(new Error('请输入不为0正整数!'))
                            }else{
                                callback()
                            }
                        }, trigger: 'blur' }
                    ]
                }
            },
            timer: '',
            addressData: {
                id: '',
                type: '01',//业务类型 01 进口，02 出口
                addressExplain: '3',//地址说明
                addressType: '04',//地址类型
                companyName: '',
                isEnabled: true,
                show: false,
                isReset: true //使用外部保存地址
            },
            btnLoading: false,
            supplierRules: {
                name: [
                    { required: true, message: '请选择供应商全称', trigger: 'blur'},
                    { max: 100, message: '最大长度100个字符', trigger: 'change' },
                    { validator: (rule, value, callback) => {
                        if (!/^((?!:|"|%|&|\*|（|）|<|>|@|#|\^|~|\[|\]|\|).)*$/.test(value)) {
                            callback(new Error('请录入英文名称，如有括号，请用英文输入法下的括号，请不要输入下列符号："%&*<>@#~^[]|'))
                        }
                        if (!/^[a-z\s()\.\-\/\\\,0-9']+$/i.test(value)) {
                            callback(new Error('请输入英文名称'))
                        }
                        callback()
                    }, trigger: 'blur' }
                ],
                address: [
                        { required: true, message: '请输入注册地址', trigger: 'blur'}
                ],
                areaIdDesc: [
                    { required: true, message: '请选择区域', trigger: 'blur'}
                ],
                number: [
                    { required: false, message: '请输入SWIFT号/联行号', trigger: 'blur'},
                    { validator: numberVai, trigger: ['change', 'blur'] }
                ],
                countryName: [
                    { required: false, message: '请选择国家地区', trigger: 'blur'}
                ],
                bankName: [
                    { required: false, message: '请输入开户银行', trigger: 'blur'}
                ],
                account: [
                    { required: false, message: '请输入银行账号', trigger: 'blur'},
                    { max: 200, message: '最大支持200位字符长度', trigger: 'blur' },
                    { pattern: /^((?!:|"|%|&|\*|<|>|（|）|@|#|\^|~|\[|\]|\||\s).)*$/, message: '请不要输入下列符号："%&*<>@#~^[]|及空格', trigger: 'blur' }
                ],
                currencyIdDesc: [
                    { required: false, message: '请选择币别', trigger: 'blur'}
                ],
            },
            supplierDialog: {
                title: '新增供应商',
                show: false,
                btnLoading: false,
                rules: {
                    name: [
                        { required: true, message: '请选择供应商全称', trigger: 'blur'},
                        { max: 100, message: '最大长度100个字符', trigger: 'change' },
                        { validator: (rule, value, callback) => {
                            if (!/^((?!:|"|%|&|\*|（|）|<|>|@|#|\^|~|\[|\]|\|).)*$/.test(value)) {
                                callback(new Error('请录入英文名称，如有括号，请用英文输入法下的括号，请不要输入下列符号："%&*<>@#~^[]|'))
                            }
                            if (!/^[a-z\s()\.\-\/\\\,0-9']+$/i.test(value)) {
                                callback(new Error('请输入英文名称'))
                            }
                            callback()
                        }, trigger: 'blur' }
                    ],
                    address: [
                         { required: true, message: '请输入注册地址', trigger: 'blur'}
                    ],
                    areaIdDesc: [
                        { required: true, message: '请选择区域', trigger: 'blur'}
                    ],
                    number: [
                        { required: false, message: '请输入SWIFT号/联行号', trigger: 'blur'},
                        { validator: numberVai, trigger: ['change', 'blur'] }
                    ],
                    countryName: [
                        { required: false, message: '请选择国家地区', trigger: 'blur'}
                    ],
                    bankName: [
                        { required: false, message: '请输入开户银行', trigger: 'blur'}
                    ],
                    account: [
                        { required: false, message: '请输入银行账号', trigger: 'blur'},
                        { max: 200, message: '最大支持200位字符长度', trigger: 'blur' },
                        { pattern: /^((?!:|"|%|&|\*|<|>|（|）|@|#|\^|~|\[|\]|\||\s).)*$/, message: '请不要输入下列符号："%&*<>@#~^[]|及空格', trigger: 'blur' }
                    ],
                    currencyIdDesc: [
                        { required: false, message: '请选择币别', trigger: 'blur'}
                    ],
                }
            },
            tempBillId: "",
            uploadParams: {
                coreBillIds: "",
                coreBillNumbers: "",
                sourceBillId: "",
                sourceBillNumber: "",
                sourceBillType: "EntrustAll",
                billsType: "",
                items: []
            },
            limitDrawer: {
                show: false
            },
            bizTypeDialog: {
                show: false
            },
            listCarrier: [],
            onlyCityData: []
        }
    },
    watch:{
        supplierDialog:{
            handler(){
                if(this.supplierDialog.number || this.supplierDialog.countryName || this.supplierDialog.bankName || this.supplierDialog.account || this.supplierDialog.currencyIdDesc){
                    this.supplierDialog.rules.number[0].required = true
                    this.supplierDialog.rules.countryName[0].required = true
                    this.supplierDialog.rules.bankName[0].required = true
                    this.supplierDialog.rules.account[0].required = true
                    this.supplierDialog.rules.currencyIdDesc[0].required = true
                    setTimeout(()=>{
                        this.$refs.supplierDialog.clearValidate(['number','name','address','areaIdDesc','countryName','bankName','account','currencyIdDesc'])
                    },100)
                }else{
                    this.supplierDialog.rules.number[0].required = false
                    this.supplierDialog.rules.countryName[0].required = false
                    this.supplierDialog.rules.bankName[0].required = false
                    this.supplierDialog.rules.account[0].required = false
                    this.supplierDialog.rules.currencyIdDesc[0].required = false
                    setTimeout(()=>{
                        this.$refs.supplierDialog.clearValidate(['name','address','areaIdDesc'])
                    },100)
                }
            },
            deep: true
        }
    },
    props: {
        isDisabled: {
            type: Boolean,
            default: false
        },
        dataForm: {
            type: Object
        },
        status: {
            type: Boolean,
            default: false
        },
        bizType: {
            type: Array,
            default: []
        },
        trustee: {
            type: Array,
            default: []
        },
        protocolData: {
            type: Array,
            default: []
        },
        cqList: {
            type: Array,
            default: []
        },
        payMentTerm: {
            type: Array,
            default: []
        },
        copyId: {
            type: String,
            default: ''
        },
        isTaxPayment: {
            type: Boolean,
            default: false
        },
        typeList: {
            type: Object,
            default: {}
        },
        deleteArr: {
            type: Array,
            default: []
        }
    },
    computed: {
        
        isHKchange () {
            if (this.dataForm.supplierMethodAddressId && this.dataForm.supplierMethodAddressId[1] == '4794175053496320') {
                return true
            } else {
                return false
            }
        },
        incomingRemarks: {
            get () {
                return '提货地址：' + this.dataForm.incomingAreaIdName + '-' + this.dataForm.incomingAddress  + '  联系人：' + this.dataForm.incomingLinkman + '  电话：' + this.dataForm.incomingContactNumber + '  提货时间:' + this.dataForm.incomingTime +  ' 件数:' + (this.dataForm.incomingTotalPackedQty || '') + (this.dataForm.incomingRemark ? ` 入仓号：${this.dataForm.incomingRemark}` : '')
            },
            set (val) {
                this.incomingRemarks = val
            }
        },
    },
    created () {
        this.getListCarrier()
    },
    methods:{
        getListCarrier () {
            this.$get('/tms/track17/listCarrier', {data: {}}).then(({data}) => {
                if(data && data.code === 'C0000') {
                    this.listCarrier = data.result
                }
            })            
            this.$post('/bas/basArea/list', {isEnabled: 1, type: 3}).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    this.onlyCityData = data.result
                }
            })
        },
        handlerSubmit () {
            console.log(this.dataForm)
            this.$refs.dataForm.validate((valid, fields) => {
                if (valid) {

                }
            })
        },
        must(obj){
            
            if([3,4,5,6,7,8,9,10].indexOf(obj.columnIndex) !== -1) {
			    return 'must';
		    }
        },
        getBizType () {
            if (this.bizType.length > 1) {
                this.invockType = this.dataForm.bizType
                this.bizTypeDialog.show = true
            }
        },
        setBizType () {
            this.dataForm.bizType = this.invockType
            this.changeProtocol('bizType')
            this.bizTypeClose()
        },
        changeProtocol (state) {
            if (state != 'init') {
                this.dataForm.creditRequirement = ''
            }
            this.getProtocol(this.dataForm.bizType, state)
        },
        getProtocol (bizType, state) {
            let queryData = this.dataForm.bizDate
            if (this.dataForm.clientStatusDesc == '已保存') {
                let date = new Date()
                queryData =
                date.getFullYear() +
                "-" +
                (date.getMonth() + 1) +
                "-" +
                date.getDate()
            }
            this.$post('/bas/client/servProtocol/list', {
                entrustId: this.dataForm.principalId,
                isEnable: 1,
                type: bizType,
                // trusteeId: trusteeId,
                queryDate: queryData,
                typeList: ['01', '02'],  //解决bug 28967
                status: '03'
            }).then(res => {
                if (res.data && res.data.code === 'C0000') {
                    let data = res.data.result
                    if (res.data.result.length === 1) {
                        this.setProtocol(res.data.result[0])
                    } else if (res.data.result.length > 1){
                        let trusteeName = data[0].trusteeName
                        let flag = flase
                        data.map(e => {
                            if (e.trusteeName != trusteeName) {
                                flag = true
                            }
                        })
                        if (flag) {
                            this.$confirm('您存在多个合作主体或多个协议，请与商务联系，指定1个?', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'error'
                            }).then(() => {
                                this.$emit('collback')
                            })
                        }
                    }
                }
            })
        },
        setProtocol (protocol) {
            this.dataForm.salesManId = protocol.salesmanId
            this.dataForm.salesManName = protocol.salesManName
            this.dataForm.marginRatio = protocol.marginLevel
            this.dataForm.isGoodsControlled = protocol.cargoControl
            this.dataForm.protocolName = protocol.name
            this.dataForm.protocolId = protocol.id
            this.dataForm.businessManName = protocol.businessManIdDesc
            this.dataForm.businessManId = protocol.businessManId
            this.dataForm.insurance = protocol.insurance
            this.dataForm.riskControlId = protocol.riskControlId
            this.dataForm.trusteeId = protocol.trusteeId
            this.dataForm.trusteeName = protocol.trusteeName
            this.dataForm.cushionMoney = protocol.cushionMoney
            this.dataForm.taxPayment = protocol.taxPayment
            
            this.options = []
            if (protocol.cushionMoney && protocol.taxPayment) { //协议中带出垫货款，和垫税款
                this.options = this.cqList
                //默认点货款及税款
                // if (!this.dataForm.creditRequirement) {
                //     this.dataForm.creditRequirement = '3'
                // }
            } else {
                // this.cqList.map(e => {
                //     if (protocol.cushionMoney && (e.desc == '垫货款' || e.desc == '无资金需求')) { //协议带出垫货款
                //         if (e.desc == '垫货款' &&　!this.dataForm.creditRequirement) {
                //             this.dataForm.creditRequirement = e.value
                //         }
                //         this.options.push(e)
                //     }
                //     if (protocol.taxPayment && (e.desc == '垫税款' || e.desc == '无资金需求')) {//协议带出垫税款
                //         if (e.desc == '垫税款' && !this.dataForm.creditRequirement) {
                //            this.dataForm.creditRequirement = e.value
                //         }
                //         this.options.push(e)
                //     }
                //     if (!protocol.taxPayment && !protocol.cushionMoney && e.desc == '无资金需求') {//协议啥没带出，默认无资金需求
                //         if (!this.dataForm.creditRequirement) {
                //             this.dataForm.creditRequirement = e.value
                //         }
                //         this.options.push(e)
                //     }
                // })
            }
            //this.$emit('setUploadParams')
            this.$emit('isChangeLimit', protocol)
        },
        methodChange () {
            this.dataForm.supplierCarrierId = ''
            this.dataForm.supplierCourierNumber = ''
        },
        checkedPickUp () {
            if (!this.dataForm.supplierId || !this.dataForm.supplierName) {
                this.$message({
                    type: 'error',
                    message: '请先选择供应商',
                    offset: 380,
                    grouping: true,
                })
            } else {
                if (this.dataForm.incomingAreaId) {
                    this.$post('/tms/deliveryNotice/updateByImport', {
                        incomingNumber: this.dataForm.incomingNumber,
                        number: this.dataForm.number
                    }).then(({ data }) => {
                        if(data.code === 'C0000') {
                            if (data.result && [3, 4].includes(data.result.status)) { // 待安排/已安排
                                this.$alert('提货单号' + this.dataForm.incomingNumber + ' ' + data.result.statusDesc + '，不可直接修改，请联系客服处理', '温馨提示', {
                                    type: 'warning',
                                    callback: action => { }
                                })
                            } else {
                                this.addPickupDialog.title = '修改提货需求'
                                this.addPickupDialog.incomingAreaId = this.dataForm.incomingAreaId
                                this.addPickupDialog.incomingAddress = this.dataForm.incomingAddress
                                this.addPickupDialog.incomingLinkman = this.dataForm.incomingLinkman
                                this.addPickupDialog.incomingContactNumber = this.dataForm.incomingContactNumber
                                this.addPickupDialog.incomingAreaIdName = this.dataForm.incomingAreaIdName
                                this.addPickupDialog.incomingTime = this.dataForm.incomingTime
                                this.openPickupDialog()
                            }
                        }
                    })
                } else {
                    this.addPickupDialog.title = '新增提货需求'
                    this.openPickupDialog()
                }
            }
        },
        openPickupDialog() {
            this.$post('/bas/client/basSupplier/entryAddressList', {pageSize: 9999, pageNum: 1, supplierId: this.dataForm.supplierId}).then(({data}) => {
                if(data.result && data.result.list && data.result.list.length > 0) {
                    data.result.list.forEach(ele=>{
                        if(ele.isDefault === 1) {
                            this.handleSelect(ele)
                        }
                    })
                }
            })
            this.addPickupDialog.show = true
        },
        handleSelect (item) {
            if (item.state == 'add') {
                this.addressData.companyName = this.dataForm.supplierName
                this.addressData.sourceBillId = this.dataForm.supplierId
                this.addressData.defaultAddress = '中国香港/香港'
                this.addressData.sourceBillType = 'Supplier'
                this.addressData.isDefaultAdd = true
                this.addressData.show = true
            } else {
                this.addPickupDialog.incomingAddress = item.linkAddress
                this.addPickupDialog.incomingAreaId = item.areaIdDesc
                this.addPickupDialog.incomingLinkman = item.linkman
                this.addPickupDialog.incomingContactNumber = item.mobile
                this.addPickupDialog.incomingTime = item.incomingTime || this.dataForm.incomingTime
                this.addPickupDialog.incomingAreaIdName = item.areaDesc
                this.addPickupDialog.isDefault = item.isDefault
            }
        },
        handleAddSupplier () {
            this.supplierDialog.show = true
        },
        changeSupplier (v) {
            if(this.timer) {clearTimeout(this.timer)}
            this.timer = setTimeout(() => {
                if (!v) {
                    this.dataForm.supplierId = ''
                    this.setSupplierMethod()
                } else {
                    if (v.id) {           
                        this.$post('/bas/client/basSupplier/list', {nameOrNumber: this.dataForm.supplierName}).then(({data}) => {
                            if(data && data.code === 'C0000') {
                                if(data.result) {
                                    if(!data.result.list || !data.result.list.length) {
                                        this.$confirm('该供应商还未存到您的供应商列表， 系统直接为您添加？', '提示', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        type: 'info',
                                        showClose: false,
                                        closeOnClickModal: false,
                                        closeOnPressEscape: false
                                        }).then(() => {
                                            this.$post('/bas/client/basSupplier/submit', v).then(({data}) => {
                                                if(data && data.code === 'C0000') {
                                                    this.$message({
                                                        type: 'success',
                                                        message: '添加成功！',
                                                        offset: 380,
                                                        grouping: true,
                                                    })
                                                }
                                            })
                                        }).catch(() => {
                                            this.dataForm.supplierId = ''
                                            this.dataForm.supplierName = ''
                                            setTimeout(() => {
                                                this.$refs.dataForm.clearValidate('supplierName')
                                            }, 500)
                                        })
                                    }
                                }
                            }
                        })
                        this.dataForm.supplierId = v.id
                    }
                }
                this.timer = null
            }, 500)
        },
        setSupplierMethod () {
            if (this.dataForm.supplierMethod == '02') {
                this.dataForm.supplierMethod = ''
                this.dataForm.incomingAreaId = ''
                this.dataForm.incomingAddress = ''
                this.dataForm.incomingLinkman = ''
                this.dataForm.incomingContactNumber = ''
                this.dataForm.incomingAreaIdName = ''
            }
        },
        closeDialog () {
            this.addPickupDialog.show = false
        },
        handlerAddress (item) {
            this.addPickupDialog.incomingAreaId = item.address
            this.addPickupDialog.incomingAddress = item.addressContent
            this.addPickupDialog.incomingLinkman = item.linkMan
            this.addPickupDialog.incomingContactNumber = item.linkPhone
            this.addPickupDialog.incomingAreaIdName = item.areaDesc
            this.addPickupDialog.isDefault = item.isDefault
        },
        submitLinkman (item) {
            this.$refs.handlerAds.isloading = true
            this.$post('/bas/client/basSupplier/checkSupplierLinkmanEntry', {parentId: this.dataForm.supplierId, linkAddress: item.addressContent}).then(res => {
                if (res.data.code === 'C0000') {
                    let obj = res.data.result
                    this.$post('/bas/client/basSupplier/submitLinkman', {
                        id: obj ? obj.id : '',
                        parentId: this.dataForm.supplierId,
                        linkman: item.linkMan,
                        company: item.companyName,
                        mobile: item.linkPhone,
                        isDefault: item.isDefault,
                        addressDescription: item.addressExplain, //地址说明
                        bizType: item.bizTypeGroup, //业务类型
                        addressType: item.addressType,
                        areaIdDesc: item.address,
                        linkAddress: item.addressContent,
                        areaId: item.address.join(',')
                    }).then(res => {
                        if (res.data.code === 'C0000') {
                            this.handlerAddress(item)
                            this.$refs.handlerAds.isloading = false
                            this.$refs.handlerAds.handleClose()
                        }
                    }).finally(() =>{
                        if (this.$refs.handlerAds) {
                            this.$refs.handlerAds.isloading = false
                        }
                    })
                }
            })
        },
        confirmDialog () {
            this.$refs.addPickupDialog.validate((valid) => {
                if (valid) {
                    this.dataForm.incomingAreaId = this.addPickupDialog.incomingAreaId
                    this.dataForm.incomingAddress = this.addPickupDialog.incomingAddress
                    this.dataForm.incomingLinkman = this.addPickupDialog.incomingLinkman
                    this.dataForm.incomingContactNumber = this.addPickupDialog.incomingContactNumber
                    this.dataForm.incomingRemark = this.addPickupDialog.incomingRemark
                    this.dataForm.incomingAreaIdName = this.addPickupDialog.incomingAreaIdName
                    this.dataForm.incomingTime = this.addPickupDialog.incomingTime
                    this.dataForm.incomingTotalPackedQty = this.addPickupDialog.incomingTotalPackedQty
                    this.closeDialog()
                }
            })
        },
        downloadRecePdf (url) {
            let eleLink = document.createElement("a")
            eleLink.download = ""
            eleLink.target = "_blank"
            eleLink.style.display = "none"
            // 字符内容转变成blob地址
            eleLink.href = url
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)
        },
        setUploadParams () {
            this.$emit('setUploadParams')
        },
        changeNewSupplier (item) {
            this.supplierDialog.address = item.address
            this.supplierDialog.areaIdDesc = item.areaIdDesc || []
            this.supplierDialog.name = item.name
            this.supplierDialog.supplierId = item.id
            this.$refs.supplierDialog.validateField('name')
            if(item.id){
                this.fileData.sourceBillId = item.id
            }else{
                this.fileData.sourceBillId = ''
            }
        },
        supplierConfigDialog () {
            this.$refs.supplierDialog.validate((valid) => {
                if (valid) {
                    if(this.isDisabl2 && this.fileList.length < 1) {
                        this.$message({
                            type: 'error',
                            message: '新账号请上传银行资料盖章件! ',
                            appendTo: '.account-dialog',
                            grouping: true,
                            offset: 160
                        })
                        return
                    }
                    this.supplierDialog.btnLoading = true
                    let params = {
                        name: this.supplierDialog.name,
                        address: this.supplierDialog.address,
                        areaId: this.supplierDialog.areaId,
                        supplierId: this.supplierDialog.supplierId,
                        shortName: this.supplierDialog.name.substring(0, this.supplierDialog.name.indexOf(' ') != -1 ? this.supplierDialog.name.indexOf(' ') : this.supplierDialog.name.length),
                        status: 2,
                        supplierAccountList: [
                            {
                                account: this.supplierDialog.account,
                                currencyId: this.supplierDialog.currencyId,
                                currencyIdDesc: this.supplierDialog.currencyIdDesc,
                                bankName: this.supplierDialog.bankName,
                                countryId: this.supplierDialog.countryId,
                                countryName: this.supplierDialog.countryName,
                                number: this.supplierDialog.number
                            }
                        ]
                    }
                    if(!this.supplierDialog.number){
                        params.supplierAccountList = []
                    }
                    if(this.supplierDialog.bank){
                        params.supplierAccountList[0].bank = this.supplierDialog.bank
                    }
                    if(this.supplierDialog.tempBillId){
                        params.tempBillId = this.supplierDialog.tempBillId
                    }
                    this.$post('/bas/client/basSupplier/submit', params).then(({data}) => {
                        if (data && data.code == 'C0000') {
                            this.dataForm.supplierName = this.supplierDialog.name
                            this.dataForm.supplierId = data.result
                            this.closeSupplier()
                        }
                    }).finally(() => {
                        this.supplierDialog.btnLoading = false
                    })
                }
            })
        },
        closeSupplier () {
            this.fileList = []
            this.$refs.supplierDialog.resetFields()
            this.supplierDialog.number = ''
            this.supplierDialog.tempBillId = ''
            this.fileData.sourceBillId = ''
            this.supplierDialog.show = false
        },
        selectArea (areaId, areaList) {
            this.supplierDialog.areaList = areaList || []
            this.supplierDialog.areaId = areaId.join(',')
        },
        // 自动保存
        autoSave() {
            this.$emit('autoSave')
        },
        updateBillsId(billsId) {
            this.tempBillId = billsId
        },
        validate () {
            return new Promise((resolve, reject) => {
                this.$refs.dataForm.validate((valid, fields) => {
                    if (value) {
                        return resolve(this.dataForm)
                    } else {
                        reject(fields)
                    }
                })
            })
        },
        handlerLimit () {
            if (this.dataForm.applyStatus != 2) {
                this.limitDrawer.show = true
            } else {
                this.$router.push({
                    path: '/my-quota'
                })
            }
            
        },
        bizTypeClose() {
            this.bizTypeDialog.show = false
        },
        chenckedType (type) {
            this.invockType = type
        },
        stepline () {
            let str = '120px'
            if (this.dataForm.supplierMethod == '01') {
                str = '178px'
            }
            if (this.dataForm.supplierMethod == '02') {
                str = '186px'
                if (this.dataForm.incomingAreaIdName) {
                    str = '178px'
                } else {
                    str = '130x'
                }
                
            }
            return str
        },
        changCarrier () {
            this.listCarrier.map(e => {
                if (e.id == this.dataForm.supplierCarrierId) {
                    this.dataForm.supplierCarrierName = e.name
                }
            })
        },
        //新增供应商
        bankChange(obj){
            if(obj.id){
                this.supplierDialog.bank = obj.id
                this.supplierDialog.bankName = obj.name
                this.supplierDialog.number = obj.number
                this.supplierDialog.countryId = obj.countryId
                this.supplierDialog.countryName = obj.countryIdDesc
                this.supplierDialog.rowDis = true
                this.isDisabl2 = false
            }else{
                this.supplierDialog.number = obj.name
                this.supplierDialog.bank = ''
                this.supplierDialog.countryName = ''
                this.supplierDialog.countryId = ''
                this.supplierDialog.bankName = ''
                this.isDisabl2 = true
            }
        },
        //币别
        currencyChange(obj){
            if(obj){
                this.supplierDialog.currencyId = obj.id
                this.supplierDialog.currencyIdDesc = obj.name
            }else{
                this.supplierDialog.currencyId = ''
                this.supplierDialog.currencyIdDesc = ''
            }
        },
        //国家地区
        countryChange(obj){
            if(obj) {
                this.supplierDialog.countryId = obj.id
                this.supplierDialog.countryName = obj.name
            }else{
                this.supplierDialog.countryId = ''
                this.supplierDialog.countryName = ''
            }
        },
        // 更新附件id
        updateBillsId2 (tempBillId) {
            this.supplierDialog.tempBillId = tempBillId;
        },
        changefileData (file) {
            if (file && file.id) {
                let temp = []
                if (!this.fileList) {
                    temp.push(file)
                    this.fileList = temp
                } else {
                    this.fileList.push(file)
                }
            }
        },
        supplierClose(){

        }
    }
}
</script>

<style lang="scss">
.import-detail-edit {
    .incoming-div {
        margin-bottom: 38px;
        .icon-svg {
            width: 11px;
            height: 16px;
            vertical-align: middle;
        }
    }
   
    padding-bottom: 30px;
    .el-form-item {
        margin-bottom: 40px;
    }
    // .form-item-a {
    //     .el-form-item {
    //         margin-bottom: 30px;
    //     }
    // }
    text-align: left;
    border-top: 1px solid #F0F2F5;
    color: #000000;
    .el-table th.must>.cell:after {
	    content: ' *';
	    color: #ff1818;
    }
    .el-form-item__label{
        color: #000000;
        font-size: 14px;
    }
    .biz-type {
        height: 35px;
        line-height: 35px;
        background-color: #F2F7FF;
        border-radius: 0 0 8px 8px;
        width: 270px;
        text-align: center;
        cursor: pointer;
        .icon-svg {
            vertical-align: middle;
            width: 14px;
            height: 14px;
        }
    }
    .tax-limit {
        margin-top: 30px;
        height: 80px;
        width: 453px;
        border:2px solid #0A7CFF;
        border-radius: 15px;
        position: relative;
        display: flex;
        .limit-left {
            width: 140px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .msg-center {
            width: 250px;
            margin-top: 15px;
            text-align: left;
            padding: 0 20px;
            color:#000000;
            .number {
                font-size: 18px;
                color:#F87243;
                line-height: 1.5;
            }
            .by {
                font-size: 12px;
            }
        }
        .msg-right{
            width: 145px;
            border-left: 2px solid #eeeeee;
            margin: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #0A7CFF;
            cursor: pointer;
            .icon-svg {
                width: 25px;
                height: 25px;
                vertical-align: middle;
            }
            div {
                display: flex;
                align-items: center;
            }
            
        }
    }
    .is-taxes {
        border: 2px solid #eeeeee;
        .title {
            background-color: #eeeeee;
        }
    }
    .title-1 {
        color: #000000;
        line-height: 40px;
        font-size: 18px;
        margin: 30px 0 40px 0;
    }
    .consignee {
        position: relative;
        border-bottom: 1px solid #F0F2F5;
        .logo {
            float: left;
            width: 54px;
            .icon-svg {
                width: 54px;
                height: 74px;
            }
            .step-line {
                width: 2px;
                height: 130px;
                background: linear-gradient(to bottom, #88B2E9, #88B2E9 7.5px, transparent 7.5px, transparent);
                background-size: 100% 15px;
                margin-left: 26px;
            }
           
        }
        .content {
            float: left;
            margin-left: 40px;
            width: calc(100% - 95px);
            .supplierName{
                width: 100%;
                display: flex;
                padding: 20px 0;
                border-bottom: 1px solid #F0F2F5;
                line-height: 24px;              
                .supplier{
                    padding: 5px 12px;
                    height: 24px;
                    line-height: 14px;
                    border-radius: 4px;
                    background-color: #F0F2F5;
                    span{
                        color: #FE2424;
                    }
                }
                .icon-svg{
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    margin: 0 10px;
                    cursor: pointer;
                }
                p{
                    font-size: 22px;
                    font-weight: bold;                    
                }
            }
            .basics-label {
                width: 100%;
                display: flex;
                padding-top: 28px;
                line-height: 60px;
                cursor: pointer;
                .icon-svg{
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    margin: 20px 10px;
                    cursor: pointer;
                }
                p{
                    font-size: 14px;
                    // font-weight: bold;                    
                }
            }
            .receivingAddress{
                font-size: 14px;
                font-weight: 400;
                margin-bottom: 40px;
                .el-icon{
                    vertical-align: middle;
                }
            }
        }
        .jiantou {
            height: 12px;
            text-align: center;
            .icon-svg {
                vertical-align: super;
                width: 12px;
                height: 12px;
            }
        }
        
    }
    .cargoInfo{
        padding-top: 28px;
       .title-2 {
         display: flex;
         justify-content: space-between;
         margin-bottom: 20px;
         .left{
            display: flex; 
            align-items: center;
            h3{
               font-size: 18px;
               margin-right: 25px;
               white-space: nowrap;
            }
            .text{
                font-size: 14px;
                color: #000000;
                margin-right: 10px;
                span{
                    color: #FE2424;
                    margin: 0 20px 0 3px;
                }
                i{
                    display: inline-block;
                    width: 1px;
                    height: 14px;
                    background-color:#A0A0A0 ;
                   
                }
            }
         }
        .el-form-item {
            margin-bottom:0px
        }
       }
       .el-alert{
        background-color: #FEEAE3;
        color:#F87243 ;
        span{
            font-size: 14px;
        }
           
       }
       .el-table{
        margin-top: 20px;
        .el-table__header-wrapper{
            .el-table-column--selection.is-leaf.el-table__cell{
                border-right: 0px;
            }
        }
        .el-table__body-wrapper{
            td{
                border-bottom: 1px solid #F0F2F5;
            }
           .el-table-column--selection.el-table__cell{
                border-right: 0px;
            }
            
            
           
        }

       }
       .addCargo{
        width: 100%;
        padding: 0 20px;
        height: 45px;
        margin-bottom:40px ;
        background-color: #F2F7FF;
        text-align: left;
        font-size: 14px;
        line-height: 45px;
        span {
            cursor: pointer;
        }
        .icon-svg{
            width: 24px;
            height: 24px;
            vertical-align: middle;
            cursor: pointer;
        }
       }
       .cargoMoney{
        margin-bottom: 40px;
        & > div{
            flex: 1;
            h5{
                font-size: 14px;
                font-weight: 400;
                margin-bottom: 20px;
            }
            div{
                font-size: 30px;
                font-weight: 500;
            }
        }
       }
       .cargoRemark{
         .el-form-item{
             margin-bottom: 8px;
         }
       
         h5{
            margin-bottom: 15px;
            font-weight: 400;
            font-size: 14px;
         }
         .el-textarea{
                      
            .el-textarea__inner{               
                min-height:45px !important;
                padding-top: 11px;
            }
         }
         .alert{
            display: flex;
            .el-alert{
                margin-right: 8px;
                // max-width: 250px;
                // cursor: pointer;
                
                // .el-alert__title {
                //     overflow: hidden;
                //     white-space: nowrap;
                //     text-overflow: ellipsis;
                // }
            }
         }
       }
       .upload {
        margin: 40px 0;
          h5 {
            margin-bottom: 10px;
            font-size: 14px;
          }
          i {
            color: #ff2626;
          }
          & > div {
            display: flex;
            justify-content: space-between;
            .displaybox {
              width: 100%;
              height: 45px;
              padding: 5px;
              margin-left: 20px;
              background-color: #f0f2f5;
              border-radius: 6px;
              div {
                display: inline-block;
                padding: 0 8px 0 15px;
                margin-right: 7px;
                height: 35px;
                line-height: 35px;
                background-color: #fff;
                border-radius: 8px;
                span {
                  margin-right: 30px;
                }
                .icon-svg {
                  width: 19px;
                  height: 19px;
                  vertical-align: middle;
                  cursor: pointer;
                }
                .one {
                  margin-right: 7px;
                }
              }
            }
          }
       }
       .Coupons{
        display: flex;
        margin-bottom: 20px;
        .el-form-item{
            margin-right: 30px;
        }
       }
    }
    
    .footer {
        margin: 20px;
        text-align: center;
        
    }
    .hk-adress {
        margin-top: 36px;
        display: inline-block;
    }
    .kg-change-title {
        color: #f58507;
        background-color: #f3ffe0;
        line-height: 28px;
        margin-top: 40px;
        display: inline-block;
    }
    .edit-incoming {
        
        .el-icon {
            color: #0f7eff;
            vertical-align: middle;
            margin-right: 5px;
        }
    }
    .no-min-height {
        padding: 0 30px;
        .el-dialog__header{
            margin-right: initial;
            button{
                right: 20px;
            }
        }
        .el-autocomplete {
            width: 100%;
        }
    }
    .auto-complete-select {
        padding: 0 0 10px 0!important;
    }
}
.jw-order-edit {
    .biz-btn {
        text-align: right;
    }
    .edit-radio {
        width: 100%;
    }
    .ml-4 {
        margin: 10px
    }
}
.no-min-height {
    .el-autocomplete {
        width: 100%;
    }
}

.basics-label1 {
    .el-form-item__content {
        padding-top: 35px;
    }
}

.bizType-dialog {
    .el-dialog__footer {
        text-align: center;
        padding-top: 0;
    }
    .el-dialog__body {
        padding: 40px;
    }
    .org-item {
        width: 100%;
        height: 60px;
        border-radius: 15px;
        position: relative;
        border: 2px solid #EEEEEE;
        margin-bottom: 20px;
        cursor: pointer;
        &.isActived {
            border: 2px solid #0a7cff;
            .org-tel {
                background-color: #0a7cff;
            }
        }
        .org-tel {
            width: 37px;
            height: 36px;
            background-color: #EEEEEE;
            color: #ffffff;
            border-radius: 15px 0 15px 0;
            position: absolute;
            cursor: pointer;
            top: -2px;
            left: -2px;
            .el-icon {
                margin: 12px;
                width: 12px;
                height: 8px;
                font-weight: bold;
            }
        }
        .org-name {
            font-size: 16px;
        }
        div:last-child {
            text-align: center;
            line-height: 60px;
        }

    }

    

}
</style>